// import { X } from 'lucide-react';
// import { useState } from 'react';
// import { useUpdateSellerStatus } from '../hooks/useUpdateSellerStatus';

// const StatusUpdateModal = ({ isOpen, onClose, seller }) => {
//   const [status, setStatus] = useState(seller?.status || '');
//   const [reason, setReason] = useState('');
//   const { mutate: updateStatus, isPending } = useUpdateSellerStatus();

//   if (!isOpen) return null;

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     updateStatus(
//       {
//         sellerId: seller._id,
//         status,
//         rejectedReason: reason || undefined,
//         suspensionReason: reason || undefined,
//       },
//       {
//         onSuccess: () => {
//           onClose();
//           setReason('');
//         },
//       }
//     );
//   };

//   const statusOptions = [
//     { value: 'active', label: 'Active', description: 'Seller can accept orders' },
//     { value: 'inactive', label: 'Inactive', description: 'Seller is temporarily inactive' },
//     // { value: 'suspended', label: 'Suspended', description: 'Seller is suspended' },
//     // { value: 'blocked', label: 'Blocked', description: 'Seller is permanently blocked' },
//     { value: 'rejected', label: 'Rejected', description: 'Seller application rejected' },
//     // { value: 'pending_approval', label: 'Pending Approval', description: 'Awaiting admin approval' },
//   ];

//   return (
//     <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
//       <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4'>
//         {/* Header */}
//         <div className='flex items-center justify-between p-6 border-b border-border'>
//           <h2 className='text-lg font-semibold text-foreground'>Update Seller Status</h2>
//           <button
//             onClick={onClose}
//             className='text-muted-foreground hover:text-foreground transition-colors'
//             disabled={isPending}
//           >
//             <X size={20} />
//           </button>
//         </div>

//         {/* Content */}
//         <form onSubmit={handleSubmit} className='p-6 space-y-4'>
//   <div>
//     <label className='block text-sm font-medium text-foreground mb-2'>
//       Select Status
//     </label>

//     <div className='space-y-2'>
//       {statusOptions.map((option) => (
//         <label
//           key={option.value}
//           className={`flex items-start p-3 border rounded-md transition-colors ${
//             seller?.status === option.value
//               ? 'opacity-50 bg-gray-100 cursor-not-allowed'
//               : 'border-border cursor-pointer hover:bg-accent'
//           }`}
//         >
//           <input
//             type='radio'
//             name='status'
//             value={option.value}
//             checked={status === option.value}
//             onChange={(e) => setStatus(e.target.value)}
//             disabled={seller?.status === option.value}
//             className={'mt-1 !bg-none checked:!bg-blue-500 !border-none focus:!outline-none'}
//             required
//           />

//           <div className='ml-3'>
//             <div className='text-sm font-medium text-foreground capitalize'>
//               {option.label}
//               {seller?.status === option.value && (
//                 <span className='ml-2 text-xs text-muted-foreground'>
//                   (Current)
//                 </span>
//               )}
//             </div>

//             <div className='text-xs text-muted-foreground'>
//               {option.description}
//             </div>
//           </div>
//         </label>
//       ))}
//     </div>
//   </div>

//   {/* {status === 'rejected' && (
//     <div>
//       <label
//         htmlFor='reason'
//         className='block text-sm font-medium text-foreground mb-2'
//       >
//         Reason (Required)
//       </label>

//       <textarea
//         id='reason'
//         value={reason}
//         onChange={(e) => setReason(e.target.value)}
//         rows={3}
//         className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
//         placeholder='Enter rejection reason...'
//         required
//       />
//     </div>
//   )} */}

//   {/* Footer */}
//   <div className='flex justify-end gap-3 pt-4'>
//     <button
//       type='button'
//       onClick={onClose}
//       disabled={isPending}
//       className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
//     >
//       Cancel
//     </button>

//     <button
//       type='submit'
//       disabled={
//         isPending ||
//         !status ||
//         status === seller?.status
//       }
//       className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
//     >
//       {isPending ? 'Updating...' : 'Update Status'}
//     </button>
//   </div>
// </form>
//       </div>
//     </div>
//   );
// };

// export default StatusUpdateModal;




import { X } from 'lucide-react';
import { useState } from 'react';
import { useUpdateSellerStatus } from '../hooks/useUpdateSellerStatus';

const StatusUpdateModal = ({ isOpen, onClose, seller }) => {
  const [status, setStatus] = useState(seller?.status || '');
  const [reason, setReason] = useState('');
  const { mutate: updateStatus, isPending } = useUpdateSellerStatus();

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    updateStatus(
      {
        sellerId: seller._id,
        status,
        rejectedReason: reason || undefined,
        suspensionReason: reason || undefined,
      },
      {
        onSuccess: () => {
          onClose();
          setReason('');
        },
      }
    );
  };

  const statusOptions = [
    { value: 'active', label: 'Active', description: 'Seller can accept orders', radioClass: 'checked:!bg-green-500' },
    { value: 'inactive', label: 'Inactive', description: 'Seller is temporarily inactive', radioClass: 'checked:!bg-blue-500' },
    // { value: 'suspended', label: 'Suspended', description: 'Seller is suspended' },
    // { value: 'blocked', label: 'Blocked', description: 'Seller is permanently blocked' },
    { value: 'rejected', label: 'Rejected', description: 'Seller application rejected', radioClass: 'checked:!bg-red-500' },
    // { value: 'pending_approval', label: 'Pending Approval', description: 'Awaiting admin approval' },
  ];

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
      <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4'>
        {/* Header */}
        <div className='flex items-center justify-between p-6 border-b border-border'>
          <h2 className='text-lg font-semibold text-foreground'>Update Seller Status</h2>
          <button
            onClick={onClose}
            className='text-muted-foreground hover:text-foreground transition-colors'
            disabled={isPending}
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className='p-6 space-y-4'>
  <div>
    <label className='block text-sm font-medium text-foreground mb-2'>
      Select Status
    </label>

    <div className='space-y-2'>
      {statusOptions.map((option) => (
        <label
          key={option.value}
          className={`flex items-start p-3 border rounded-md transition-colors ${
            seller?.status === option.value
              ? 'opacity-50 bg-gray-100 cursor-not-allowed'
              : 'border-border cursor-pointer hover:bg-accent'
          }`}
        >
          <input
            type='radio'
            name='status'
            value={option.value}
            checked={status === option.value}
            onChange={(e) => setStatus(e.target.value)}
            disabled={seller?.status === option.value}
            className={`mt-1 !bg-none !border-none focus:!outline-none ${option.radioClass}`}
            required
          />

          <div className='ml-3'>
            <div className='text-sm font-medium text-foreground capitalize'>
              {option.label}
              {seller?.status === option.value && (
                <span className='ml-2 text-xs text-muted-foreground'>
                  (Current)
                </span>
              )}
            </div>

            <div className='text-xs text-muted-foreground'>
              {option.description}
            </div>
          </div>
        </label>
      ))}
    </div>
  </div>

  {/* {status === 'rejected' && (
    <div>
      <label
        htmlFor='reason'
        className='block text-sm font-medium text-foreground mb-2'
      >
        Reason (Required)
      </label>

      <textarea
        id='reason'
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={3}
        className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
        placeholder='Enter rejection reason...'
        required
      />
    </div>
  )} */}

  {/* Footer */}
  <div className='flex justify-end gap-3 pt-4'>
    <button
      type='button'
      onClick={onClose}
      disabled={isPending}
      className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
    >
      Cancel
    </button>

    <button
      type='submit'
      disabled={
        isPending ||
        !status ||
        status === seller?.status
      }
      className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
    >
      {isPending ? 'Updating...' : 'Update Status'}
    </button>
  </div>
</form>
      </div>
    </div>
  );
};

export default StatusUpdateModal;